(() => {
  const products = {
    'collagen-lifting': {
      kicker: '3-STEP FACIAL CARE · MADE IN KOREA',
      title: 'Anti-Aging Collagen Lifting Mask',
      lead: 'A complete at-home ritual that hydrates, visibly firms and seals in nourishment overnight.',
      image: 'collagen-lifting-01.webp',
      details: '<h4>THE RITUAL</h4><ul><li>Hydrating collagen and hyaluronic acid ampoule</li><li>Firming collagen, elastin and peptide sheet mask</li><li>Squalane and ginseng night cream</li></ul><h4>THE EDIT</h4><p>Lift · Firm · Brighten</p>'
    },
    hyaluron: {
      kicker: '3-STEP HYDRATION · MADE IN KOREA',
      title: 'Anti-Aging Hyaluron Moisture Mask',
      lead: 'Three molecular weights of hyaluronic acid deliver immediate plumping, lasting moisture and barrier support.',
      image: 'hyaluron-01.webp',
      details: '<h4>THE RITUAL</h4><ul><li>Multi-layered hyaluronic acid ampoule</li><li>Collagen and madecassoside sheet mask</li><li>Squalane, ginseng and tremella night cream</li></ul><h4>THE EDIT</h4><p>Plump · Soothe · Restore</p>'
    },
    'deep-collagen': {
      kicker: '2–3 HOURS OR OVERNIGHT · MADE IN KOREA',
      title: 'Deep Collagen Color-Changing Mask',
      lead: 'A next-generation mask that begins opaque and turns transparent as the collagen and peptide formula is absorbed.',
      image: 'deep-collagen-01.webp',
      details: '<h4>THE COMPLEX</h4><ul><li>Hydrolyzed collagen and elastin</li><li>Multi-peptide signal complex</li><li>Centella, madecassoside and ceramide</li></ul><h4>THE EDIT</h4><p>Firm · Plump · Transform</p>'
    },
    radiance: {
      kicker: '3-STEP GLOW RITUAL · MADE IN KOREA',
      title: 'Radiance Kit',
      lead: 'A weekly three-step ritual that combines gentle AHA exfoliation, a soothing mask and a brightening serum.',
      image: 'radiance-01.webp',
      details: '<h4>THE RITUAL</h4><ul><li>Glycolic and lactic acid peeling glove</li><li>Hyaluronic acid and madecassoside mask</li><li>Niacinamide and multi-fruit brightening serum</li></ul><h4>THE EDIT</h4><p>Exfoliate · Brighten · Hydrate</p>'
    },
    peeling: {
      kicker: '10–20 MINUTES · MADE IN KOREA',
      title: 'Youth Boosting Peeling Mask',
      lead: 'A dual-action mask that pairs gentle AHA exfoliation with peptides and deep hydration for renewed-looking skin.',
      image: 'peeling-01.webp',
      details: '<h4>THE COMPLEX</h4><ul><li>Acetyl hexapeptide-8 and palmitoyl pentapeptide-4</li><li>Multi-layered hyaluronic acid</li><li>Niacinamide, lactic acid and calming botanicals</li></ul><h4>THE EDIT</h4><p>Resurface · Hydrate · Renew</p>'
    },
    serum: {
      kicker: '10–20 MINUTES · MADE IN KOREA',
      title: 'Youth Boosting Serum Mask',
      lead: 'A concentrated peptide treatment with multi-layered hyaluronic acid and soothing botanicals.',
      image: 'serum-01.webp',
      details: '<h4>THE COMPLEX</h4><ul><li>Advanced peptide complex</li><li>Multi-layered hyaluronic acid</li><li>Niacinamide, aloe, cucumber, chamomile and centella</li></ul><h4>THE EDIT</h4><p>Brighten · Firm · Plump</p>'
    }
  };

  const drawer = document.querySelector('[data-drawer]');
  const backdrop = document.querySelector('[data-backdrop]');
  const assetBase = document.querySelector('.elle-logo img')?.src.replace(/elle-logo[^/]*$/, '');
  let lastTrigger = null;

  function openProduct(key, trigger) {
    const item = products[key];
    if (!item || !drawer) return;
    lastTrigger = trigger || null;
    drawer.querySelector('[data-drawer-kicker]').textContent = item.kicker;
    drawer.querySelector('[data-drawer-title]').textContent = item.title;
    drawer.querySelector('[data-drawer-lead]').textContent = item.lead;
    drawer.querySelector('[data-drawer-details]').innerHTML = item.details;
    const image = drawer.querySelector('[data-drawer-image]');
    image.src = (assetBase || '') + item.image;
    image.alt = item.title;
    drawer.classList.add('is-open');
    backdrop?.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-close-product]')?.focus();
  }

  function closeProduct() {
    drawer?.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lastTrigger?.focus();
  }

  document.querySelectorAll('[data-product] [data-open-product]').forEach(button => {
    button.addEventListener('click', () => openProduct(button.closest('[data-product]').dataset.product, button));
  });
  document.querySelectorAll('[data-open-direct]').forEach(button => button.addEventListener('click', () => openProduct(button.dataset.openDirect, button)));
  document.querySelectorAll('[data-close-product]').forEach(button => button.addEventListener('click', closeProduct));
  backdrop?.addEventListener('click', closeProduct);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeProduct(); });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
  }, { threshold: .12 });
  document.querySelectorAll('.elle-reveal').forEach(item => observer.observe(item));

  const menu = document.querySelector('[data-menu]');
  menu?.addEventListener('click', () => {
    const nav = document.querySelector('.elle-nav');
    const open = menu.getAttribute('aria-expanded') === 'true';
    menu.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('is-open', !open);
  });
})();
